import {
  configureStore,
  combineReducers,
  Action,
  getDefaultMiddleware
} from '@reduxjs/toolkit'
import { createWrapper } from 'next-redux-wrapper'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ThunkAction } from 'redux-thunk'

import * as reducers from './modules'
import { logout } from './modules/user/user.slice'

const combinedReducer = combineReducers(reducers)

const rootReducer = (state: any, action: Action): any => {
  let newState = state

  if (action.type === logout.type) {
    newState = undefined
  }

  return combinedReducer(newState, action)
}

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false
})

const store = (): any =>
  configureStore({
    reducer: rootReducer,
    middleware: customizedMiddleware
  })

export type AppState = ReturnType<typeof combinedReducer>
// export type AppDispatch = typeof store().dispatch
export type AppThunk<R> = ThunkAction<R, AppState, unknown, Action<string>>

export const wrapper = createWrapper(store, { debug: true })

export default store
